<template>
    <section>
        <div id="mapbox-map" class="mapbox"></div>
        <!-- <a @click="generateMapbox('showRoute')">Routebeschrijving</a> -->
    </section>
</template>
<style scoped>
@import url('https://api.mapbox.com/mapbox-gl-js/v0.53.0/mapbox-gl.css');
@import url('https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-directions/v4.0.0/mapbox-gl-directions.css');
.mapbox { width: 100%; height: 70vh; }
.mapboxgl-popup { max-width: 200px; }
.marker {
  /*background-image: url('http://acc.verhuurderzoeken.nl/images/logo/logo.png');*/
  background-color: red;
  background-size: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}
.mapboxgl-popup {
  max-width: 200px;
}

.mapboxgl-popup-content {
  text-align: center;
  /*font-family: 'Open Sans', sans-serif;*/
}
.mapboxgl-popup-content {
    padding: 25px 20px 15px!important;
}
</style>

<script>
import 'mapbox-gl/dist/mapbox-gl.css'
    export default {
        name: 'contact-map',
        mounted() {
            console.info('GenerateMapbox');
            this.generateMapbox();
        },
        data() {
            return {
                latitude: 52.696390,
                longitude: 6.206910,
                title: 'Coding Agency',
                route: 'https://maps.apple.com/?q=Coding%20Agency,%207943Pe,%20Meppel,%20NL',
            }
        },
        methods: {
            generateMapbox(showRouteDescription) {
                var self = this;
                var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');
                // var MapboxLanguage = require('@mapbox/mapbox-gl-language');
                // var MapboxDirections = require('@mapbox/mapbox-gl-directions');
                // https://docs.mapbox.com/mapbox-gl-js/api/
                mapboxgl.accessToken = 'pk.eyJ1IjoiY29kaW5nd29ya3MiLCJhIjoiY2p0cmV3NDB6MGptcjRkbXI4MGo1Y3FlMCJ9.iu-TxXAtPFcPVlcD5vcn3g';
                if(self.latitude && self.longitude) {
                    var location = [parseFloat(self.longitude), parseFloat(self.latitude)];
                    // console.warn(location);
                    var map = new mapboxgl.Map({
                        container: 'mapbox-map',
                        style: 'mapbox://styles/mapbox/light-v9',
                        center: location,
                        hash: false,
                        zoom: 16,
                        pitch: 60, // pitch in degrees
                        // bearing: -60, // bearing in degrees
                        interactive: true,
                    });

                     // disable map zoom when using scroll
                    map.scrollZoom.disable();
                    map.addControl(new mapboxgl.NavigationControl());


var geojson = {
  type: 'FeatureCollection',
  features: [{
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: location
    },
    properties: {
      title: self.title,
      route: self.route,
    }
  }]
};
map.on('load', function() {
    geojson.features.forEach(function(marker) {
    // alert(marker.properties.title)
    console.info('marker.geometry.coordinates')
    console.info(marker.geometry.coordinates)
    new mapboxgl.Marker({ color: '#fdb825' })
        .setLngLat(marker.geometry.coordinates)
        .setPopup(new mapboxgl.Popup({ offset: 40, padding: 20 }) // add popups
        .setHTML('<div class="m-4 mb-0"><h2 class="font-bold mb-0 font-serif text-agency text-3xl">' + marker.properties.title + '</h2><p class="text-agency text-lg"><a class=":hover:text-coding" href="'+marker.properties.route+'">Routebeschrijving</a></p></div>'))
        .addTo(map);
    });
});

                    // https://docs.mapbox.com/mapbox-gl-js/api/#marker
                    // map.on('load', function() {
                    //     // var popup = new mapboxgl.Popup({ offset: 25 })
                    //     // .setText('');
                    //     // var marker = new mapboxgl.Marker({
                    //     //     color: '#FF6259',
                    //     // }).setLngLat(location).addTo(map); // .setPopup(popup)
                    // })

                    // map.addControl(new MapboxLanguage());

                    // https://docs.mapbox.com/mapbox-gl-js/example/mapbox-gl-directions/
                    if(typeof showRouteDescription !== 'undefined') {
                        var mapDirections = new MapboxDirections({
                            accessToken: mapboxgl.accessToken,
                            unit: 'metric',
                            controls: {
                                inputs: true
                            },
                        });
                        // map.on('load', function() {
                        //     mapDirections.setOrigin([6.19444, 52.69583])
                        //     mapDirections.setDestination([parseFloat(self.longitude), parseFloat(self.latitude)])
                        //     map.addControl(mapDirections, 'top-left');
                        // })
                    }
                }
            },
        }
    }
</script>
